/*************************************************************
@Purpose    :   Router links
*************************************************************/
export const URL = {
	login: "/login",
	forgotPassword: "/forgot-password",
	resetPassword: "/reset-password/:resetPassword",
	modules: "",
	dashboard: "/dashboard",
	profile: "/profile",

	userDetails: "/users/onboardered-users/:slug",
	users: "/users",
	onboarderedUsers: "/users/onboardered-users",
	updateUser: "/users/onboardered-users/update-user",
	updateUserSlug: "/users/onboardered-users/:slug/edit",
	pendingRegistration: "/users/pending-registration",
	guestUsers: "/users/guest-users",
	referrals: "/users/referrals",

	restaurantDetails: "/restaurants/:slug",
	restaurants: "/restaurants",
	updateRestaurantSlug: "/restaurants/:slug/edit",
	updateRestaurant: "/restaurants",
	addRestaurant: "/restaurants/add",

	updateIntegration: "/restaurants/:slug/integrations/edit",
	addIntegration: "/restaurants/:slug/integrations/add",

	orderDetails: "/orders/:slug",
	orders: "/orders",

	giftOrderDetails: "/orders/gifts/:slug",
	giftOrders: "/orders/gifts",
	promoGifts: "/orders/promo-gifts",
	promoGiftDetails: "/orders/promo-gifts/:slug",
	promoGiftApprovalRequests: "/orders/promo-gifts/approval-requests",
	pickupOrders: "/orders/pickup",
	pickupOrderDetails: "/orders/pickup/:slug",
	deliveryOrders: "/orders/delivery",

	updateCMS: "/cms/:slug",
	CMS: "/cms",

	contentReporting: "/content-reports",
	contentReportDetails: "/content-reports/:slug",
	reportReasons: "/content-reports/report-reasons",

	updateEmailTemplate: "/email-templates/:slug",
	emailTemplates: "/email-templates",

	helpManagement: "/help-management",
	helpQueriesRestaurants: "/help-management/help-queries-restaurants",
	helpQueriesUsers: "/help-management/help-queries-users",
	helpTopics: "/help-management/help-topics",

	masterManagement: "/master-management",
	categories: "/master-management/categories",
	cuisines: "/master-management/cuisines",
	coupons: "/master-management/coupons",
	brands: "/master-management/brands",
	moods: "/master-management/moods",

	payouts: "/payouts",
	transactionsDetails: "/transactions/:slug",
	transactions: "/transactions",

	payoutsHistory: "/payouts/payouts-history",
	unClaimedGiftsPayout: "/payouts/unclaimed-gifts-transfer",

	settings: "/settings",
	generalSettings: "/settings/general-settings",
	paymentGatewaySettings: "/settings/payment-gateway-settings",
	contactSettings: "/settings/contact-settings",
	appVersionSettings: "/settings/app-version",

	faqsManagement: "/faqs-management",
	faqCategoryListing: "/faqs-management/categories",
	faqCategoryListingRestaurant: "/faqs-management/categories/restaurants",
	faqCategoryListingUser: "/faqs-management/categories/users",
	FAQs: "/faqs-management/faqs",
	faqsRestaurant: "/faqs-management/faqs/restaurants",
	faqsUser: "/faqs-management/faqs/users",

	promotions: "/promotions",
	addPromotions: "/promotions/add",
	promotionDetails: "/promotions/:slug",

	subscriptions: "/subscriptions",
	plans: "/subscriptions/plans",
	AddUpdatePlans: "/subscriptions/add",
	subscriptionsTable: "/subscriptions/table",
	addPlans: "/subscriptions/add",

	rewards: "/rewards",
	rewardRules: "/rewards/rules",
	rewardsBalance: "/rewards/balance",
	rewardsRedemptions: "/rewards/redemptions",
	rewardsLedger: "/rewards/ledger",
};
